import { Injectable, inject } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { MultiselectItem } from '@ui/aos-lib';
import { TimezoneService } from 'src/app/services/utility/timezone.service';
import {
  BaseStationModelDto,
  BaseStationResponse,
  BaseStationTable,
  BaseStationItemListResponseDto
} from './base-stations-listing-page.types';
import { BaseStationApiService } from './base-stations-listing-page.api';
import { DevicesPayload } from '../devices/components/devices.models';
import { FilterModel } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { MODEL } from '@portal/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';

@Injectable({ providedIn: 'root' })
export class BaseStationService {
  private readonly api = inject(BaseStationApiService);
  private readonly tz = inject(TimezoneService);

  private formatUtcDateTime(value: string | null | undefined): string {
    return value ? this.tz.formatLong(value) : '';
  }

  getModelsFilter(): Observable<FilterModel> {
    return this.api.getBaseStationModels().pipe(
      map((models: BaseStationModelDto[]) => {
        const modelItems: MultiselectItem[] = models.map(model => ({
          text: model.modelName,
          value: model.deviceSpecId,
          isDisabled: false
        }));

        return {
          ...MODEL,
          items: modelItems,
          selected: modelItems
        };
      })
    );
  }

  getTableData(payload: DevicesPayload): Observable<BaseStationTable> {
    const initState: BaseStationTable = { data: [], total: 0 };

    return this.api.getBaseStations(payload).pipe(
      map((response: BaseStationResponse) => {
        if (!response) return initState;

        const items = response.items ?? [];
        const tableRows = items.map((item: BaseStationItemListResponseDto) => ({
          deviceId: item.deviceId,
          deviceUID: item.deviceUID ?? null,
          model: item.model,
          deviceType: item.deviceType,
          provisioningStatus: item.provisioningStatus ?? null,
          macId: item.macId ?? null,
          backhaulConnectionConfigured: item.backhaulConnectionConfigured ?? null,
          ranConfigured: item.ranConfigured ?? null,
          provisioningDateTime: this.formatUtcDateTime(item.provisioningDateTime),
          installedBy: item.installedBy ?? null
        }));

        return {
          data: tableRows,
          total: response.totalCount ?? tableRows.length
        };
      }),
      catchError(() => of(initState))
    );
  }
}
